/* ---------- nav burger ---------- */
$(".nav_burger-wrap").on("click", function () {
  $(this).toggleClass("is-open");
  $(".nav_right").toggleClass("is-open");
  $("body").toggleClass("is-open");
});
$('.nav_close').on('click', function() {
  $('.is-open').removeClass('is-open');
});

/* ---------- nav scroll state ---------- */
window.addEventListener("scroll", function() {
  const navSections = document.querySelectorAll(".section.is-nav");
  if (window.scrollY > 50) {
    navSections.forEach(section => section.classList.add("is-sticky"));
  } else {
    navSections.forEach(section => section.classList.remove("is-sticky"));
  }
});

/* ---------- lenis smooth scroll (Webflow editor guard removed; CookieYes hook stripped) ---------- */
"use strict";
{
  const lenisInstance = new Lenis({
    lerp: 0.1,
    wheelMultiplier: 0.9,
    infinite: false,
    gestureOrientation: "vertical",
    normalizeWheel: false,
    smoothTouch: false
  });

  window.lenis = lenisInstance;

  function raf(time) {
    lenisInstance.raf(time);
    requestAnimationFrame(raf);
  }
  requestAnimationFrame(raf);

  function connectToScrollTrigger() {
    lenisInstance.on("scroll", ScrollTrigger.update);
    gsap.ticker.add((time) => {
      lenisInstance.raf(time * 500);
    });
  }

  $("[data-lenis-start]").on("click", function () {
    lenisInstance.start();
  });
  $("[data-lenis-stop]").on("click", function () {
    lenisInstance.stop();
  });
  $("[data-lenis-toggle]").on("click", function () {
    $(this).toggleClass("stop-scroll");
    if ($(this).hasClass("stop-scroll")) {
      lenisInstance.stop();
    } else {
      lenisInstance.start();
    }
  });
}

/* ---------- age gate ---------- */
/* Handler wisial na #yes-btn, czyli na CALYM bloku bramki — razem z odnosnikiem
 * "nie". Klikniecie "nie" otwieralo lego.com i przy okazji zapisywalo zgode oraz
 * wpuszczalo na strone. Teraz sluchamy wylacznie przycisku "tak". */
const yes_btn = document.querySelector('#age-yes') || document.querySelector('#yes-btn');
const age_screen = document.querySelector('.age-screen');

let isAllowed = localStorage.getItem('isAllowed');

if (!yes_btn || !age_screen) {
  // bramka usunieta z motywu — nie wysypuj reszty pliku
} else if (isAllowed === 'yes') {
  age_screen.style.display = 'none';
} else {
  // Disable Lenis scroll
  window.lenis?.stop();
}

yes_btn?.addEventListener('click', function () {
  age_screen.style.opacity = '0';

  setTimeout(() => {
    age_screen.style.display = 'none';
    localStorage.setItem('isAllowed', 'yes');

    // Re-enable Lenis scroll
    window.lenis?.start();
  }, 500); // Match this to your CSS transition
});

/* Twarde spacje (po „w", „z", „i" itd. w tlumaczeniach) SplitType traktuje jak zwykle —
 * „W" zostawalo na koncu wiersza. Przed podzialem kazda grupa slow zlaczonych twarda
 * spacja trafia do <span class="nw"> (nowrap): SplitType dzieli ja na slowa, ale
 * wiersz nie moze sie miedzy nimi zlamac. */
function keepNbsp(el) {
  if (!el || el.getAttribute('data-nbsp')) return;
  el.setAttribute('data-nbsp', '1');
  var walker = document.createTreeWalker(el, NodeFilter.SHOW_TEXT), nodes = [];
  while (walker.nextNode()) nodes.push(walker.currentNode);
  nodes.forEach(function (n) {
    if (n.nodeValue.indexOf('\u00a0') < 0) return;
    var frag = document.createDocumentFragment();
    n.nodeValue.split(/([^\s\u00a0]*(?:\u00a0[^\s\u00a0]*)+)/).forEach(function (part) {
      if (!part) return;
      if (part.indexOf('\u00a0') >= 0) {
        var s = document.createElement('span'); s.className = 'nw'; s.textContent = part.replace(/\u00a0/g, ' ');
        frag.appendChild(s);
      } else frag.appendChild(document.createTextNode(part));
    });
    n.parentNode.replaceChild(frag, n);
  });
}

/* ---------- line animations (SplitType + GSAP) ---------- */
window.addEventListener("DOMContentLoaded", (event) => {
  setTimeout(() => {
    $("[js-line-animation]").each(function (index) {
      gsap.set($(this), { autoAlpha: 1 });
      let textEl = $(this);
      let textContent = $(this).text();
      let tl;

      function splitText() {
        keepNbsp(textEl[0]);
        new SplitType(textEl, { types: "lines", tagName: "span" });
        textEl.find(".line").each(function (index) {
          let lineContent = $(this).html();
          $(this).html("");
          $(this).append(
            `<span class="line-inner" style="display: block;">${lineContent}</span>`
          );
        });
        tl = gsap.timeline({
          scrollTrigger: {
            trigger: textEl,
            start: "top bottom",
            end: "bottom bottom",
            toggleActions: "none play none "
          }
        });
        tl.fromTo(
          textEl.find(".line-inner"),
          { yPercent: 100, opacity: 1 },
          {
            yPercent: 0,
            duration: 0.3,
            opacity: 1,
            stagger: {
              amount: 0.3,
              ease: "power2.easeOut"
            }
          }
        );
      }
      splitText();

      let windowWidth = window.innerWidth;
      window.addEventListener("resize", function () {
        if (windowWidth !== window.innerWidth) {
          windowWidth = window.innerWidth;
          tl.kill();
          textEl.text(textContent);
          splitText();
        }
      });
    });
  }, 800);
});

window.addEventListener("DOMContentLoaded", (event) => {
  setTimeout(() => {
    $("[js-line-animation-delay]").each(function (index) {
      gsap.set($(this), { autoAlpha: 1 });
      let textEl = $(this);
      let textContent = $(this).text();
      let tl;

      function splitText() {
        keepNbsp(textEl[0]);
        new SplitType(textEl, { types: "lines", tagName: "span" });
        textEl.find(".line").each(function (index) {
          let lineContent = $(this).html();
          $(this).html("");
          $(this).append(
            `<span class="line-inner" style="display: block;">${lineContent}</span>`
          );
        });
        tl = gsap.timeline({
          scrollTrigger: {
            trigger: textEl,
            start: "top bottom",
            end: "bottom bottom",
            toggleActions: "none play none "
          }
        });
        tl.fromTo(
          textEl.find(".line-inner"),
          { yPercent: 100, opacity: 0 },
          {
            yPercent: 0,
            duration: 0.3,
            delay: 0.8,
            opacity: 1,
            stagger: {
              amount: 0.4,
              ease: "power2.easeOut"
            }
          }
        );
      }
      splitText();

      let windowWidth = window.innerWidth;
      window.addEventListener("resize", function () {
        if (windowWidth !== window.innerWidth) {
          windowWidth = window.innerWidth;
          tl.kill();
          textEl.text(textContent);
          splitText();
        }
      });
    });
  }, 800);
});

/* ---------- cookie settings button ----------
 * CookieYes was removed. If Shopify's own consent banner is enabled
 * (Settings -> Customer privacy -> Cookie banner), this reopens it.
 * With no banner configured the button stays inert rather than erroring.
 */
document.addEventListener('click', function (e) {
  var btn = e.target.closest && e.target.closest('[data-shopify-privacy]');
  if (!btn) return;
  e.preventDefault();
  var pb = window.Shopify && window.Shopify.privacyBanner;
  if (pb && typeof pb.showPreferences === 'function') pb.showPreferences();
});
